<template>
  <div class="sidepanel" :class="{ 'active': showSidepanel }">
    <!-- Overlay when there are unsaved changes -->
    <div v-if="hasUnsavedChanges" class="overlay"></div>
    
    <div v-if="selectedInventoryVenueWine"
      style="display: flex; justify-content: space-between; flex-direction: column; height: 100%;">
      <div class="block-one" :class="{ 'elevated': hasUnsavedChanges }">
        <b-row v-if="!isMobileView">
          <span class="font-14 color-150 w-700">{{ reduceTextFn(selectedInventoryVenueWine.venueWine.wine.winery.title, 20, true) }}</span>
        </b-row>
        <b-row v-if="!isMobileView">
          <span class="font-24 w-400 color-100 mb-xs">{{reduceTextFn( selectedInventoryVenueWine.venueWine.title, 20, true) }}</span>
        </b-row>
        <b-row v-if="!isMobileView" class="mb-s">
          <b-col class="tags font-12 w-500 color-150">
            <span class="box bg-black">{{ selectedInventoryVenueWine.venueWine.wine.wineType.title }}</span>
            <span class="box bg-black">{{ selectedInventoryVenueWine.venueWine.wine.grapeVariety.title }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-s">
          <b-col class="">
            <BottleSizeDropdown @bottle-size-changed="changeBottleSize" :selectedBottleSize="sidePanelInventoryVenueWine.bottleSize" />
          </b-col>
          <b-col class="">
            <YearDropdown @year-changed="changeYear" :selectedYear="sidePanelInventoryVenueWine.year" />
          </b-col>
        </b-row>
        <b-row v-if="duplicateProductError" class="mb-s">
          <b-col class="alert-warning p-m rounded-sm">
            <span class="font-14">{{ $t('inventory.productAlreadyExists') }}</span>
          </b-col>
        </b-row>
        <b-row class="color-100 font-14 w-700 mb-xs">
          <b-col class="rowSpaceBetween">
            {{ $t('general.ekNet') }}
            <TooltipButton v-if="!selectedInventoryVenueWine.canUpdatePurchasePrice"
              :tooltipText="$t('inventory.ekNetTooltip')" />
          </b-col>
          <b-col>
            {{ $t('general.vkGross') }}
          </b-col>
          <b-col>
            {{ $t('general.shelf') }}
          </b-col>
        </b-row>
        <b-row class="mb-s color-150">
          <b-col>
            <span class="input-euro right">
              <input min="0" type="number" :disabled="!selectedInventoryVenueWine.canUpdatePurchasePrice" v-model="sidePanelInventoryVenueWine.purchasePrice" @input="onFieldChange">
            </span>
          </b-col>
          <b-col>
            <span class="input-euro right">
              <input min="0" type="number" v-model="sidePanelInventoryVenueWine.sellingPrice" @input="onFieldChange">
            </span>
          </b-col>
          <b-col>
            <input v-model="sidePanelInventoryVenueWine.shelf" @input="onFieldChange">
          </b-col>
        </b-row>
        <!-- Save/Cancel Buttons -->
        <b-row v-if="hasUnsavedChanges" class="mb-s save-cancel-buttons">
          <b-col>
            <b-button class="btn-cancel" @click="cancelChanges">{{ $t('general.buttons.cancel') }}</b-button>
          </b-col>
          <b-col>
              <b-button class="btn-save" @click="saveChanges" :disabled="duplicateProductError">{{ $t('general.buttons.save') }}</b-button>
          </b-col>
        </b-row>
      </div>
      <div class="block-two disable-dbl-tap-zoom" :style="{ marginTop: isMobileView ? '21vh' : '26vh' }">
        <div class="number-block">
          <b-row class="color-100">
            <span class="align-center font-40"
              :class="{ 'amount-not-set': selectedInventoryVenueWine.actualAmountFloat === null }">{{
                sidePanelInventoryVenueWine.actualAmountFloat == null ? 0 : sidePanelInventoryVenueWine.actualAmountFloat }} </span>
            <span class="align-center font-12 w-700" >{{ $t('inventory.stock') }}</span>
          </b-row>
          <b-row class="number-pad font-18">
            <div class="number-row" v-for="row in numberPad" :key="row.join('')">
              <span class="number" v-for="n in row" :key="n">
                <b-button class="number" @click="addNumber(n)" :style="buttonSizeStyle">{{ n }}</b-button>
              </span>
            </div>
            <div class="bottom-row">
              <span class="number">
                <b-button class="number" @click="addComma()" :style="buttonSizeStyle">,</b-button>
              </span>
              <span class="number">
                <b-button class="number" @click="addNumber(0)" :style="buttonSizeStyle">0</b-button>
              </span>
              <div >
                <b-button @click="deleteNumber()" class="delete-btn align-center number"  :style="buttonSizeStyle"><img src="../../assets/img/arrow-v2-number-pad.svg" /></b-button>
              </div>
            </div>
						<div class="bottom-row">
              <div class="duplicate align-center cursor-pointer">
                <div class="cursor-pointer" @click="markAsDuplicate">
                  <DuplicateIconChecked v-if="sidePanelInventoryVenueWine.duplicate === true" width="24" height="24" />
                  <DuplicateIcon v-else width="24" height="24" fill="rgba(73, 80, 87, 1)" />
									<span class="font-12 pl-xs">{{ $t('inventory.markAsDuplicate') }}</span>
                </div>	
              </div>
            </div>
          </b-row>

        </div>
      </div>
      <div>
        <b-row class="buttons">
          <b-col>
            <UpButton :onClick="previousRow" :buttonText="$t('general.buttons.back')" :disabled="upButtonDisabled" />
          </b-col>
          <b-col>
            <DownButton :onClick="nextRow" :buttonText="$t('inventory.next')" />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>

</template>
<script>
import DataService from '@/services/StrapiService.js';
import DownButton from '../buttons/DownButton.vue';
import UpButton from '../buttons/UpButton.vue';
import TooltipButton from '../buttons/TooltipButton.vue';
import BottleSizeDropdown from '../BottleSizeDropdown.vue';
import YearDropdown from '../YearDropdown.vue';
import DuplicateIcon from '../icons/DuplicateIcon.vue';
import DuplicateIconChecked from '../icons/DuplicateIconChecked.vue';
import { checkForNullEmptyOrNegative, reduceText } from '@/utils/functions.js'
import Constants from '@/utils/constants.js'

export default {
  name: 'InventorySidepanel',
  props: {
    selectedInventoryVenueWine: {
      type: Object,
      default: null
    },
    selectedRowIndex: {
      type: Number,
    },
    tableLength: {
      type: Number
    },
    showSidepanel: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number
    },
    inventoryWines: {
      type: Array,
      default: () => []
    },
  },
  components: {
    DownButton,
    UpButton,
    TooltipButton,
    BottleSizeDropdown,
    YearDropdown,
    DuplicateIcon,
    DuplicateIconChecked
  },
  mounted() {
    this.checkViewportSize();
    window.addEventListener('resize', this.checkViewportSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkViewportSize);
  },
  data() {
    return {
      sidePanelInventoryVenueWine: {
        purchasePrice: 0,
        shelf: '',
        actualAmountFloat: null,
        targetAmountFloat: 0,
        duplicate: false,
        id: null,
        sellingPrice: 0,
        year: null,
        bottleSize: null
      },
      originalValues: null, // Speichert die ursprünglichen Werte
      hasUnsavedChanges: false, // Zeigt an, ob es ungespeicherte Änderungen gibt
      actualAmountFloatChanged: false,
      numberPad: [[1, 2, 3], [4, 5, 6], [7, 8, 9]],
      changeFromOutSide: false,
      duplicateProductError: false,
      isMobileView: false, // true wenn Viewport-Höhe < 820px
      buttonSize: 52, // Dynamische Button-Größe (min 52px, max 78px)
      buttonFontSize: 14, // Dynamische Font-Größe (min 14px, max 20px)
    }
  },
  computed: {
    upButtonDisabled() {
      return this.selectedRowIndex === 0 && this.currentPage === 1;
    },
    isDisabledDueToDuplicate() {
      return this.duplicateProductError;
    },
    buttonSizeStyle() {
      return {
        height: `${this.buttonSize}px`,
        width: `${this.buttonSize}px`,
        fontSize: `${this.buttonFontSize}px`,
      };
    },
  },
  watch: {
    selectedInventoryVenueWine: {
      immediate: true,
      deep: true,
      handler() {
        this.resetInputs();
        if (!this.selectedInventoryVenueWine) {
          return;
        }
        this.sidePanelInventoryVenueWine = JSON.parse(JSON.stringify(this.selectedInventoryVenueWine));
        this.originalValues = JSON.parse(JSON.stringify(this.selectedInventoryVenueWine));
        this.hasUnsavedChanges = false;
        // Set year and bottleSize from the venueWine data
        this.checkForDuplicateProduct();
      }
    }
  },
  created() {
  },
  methods: {
    checkViewportSize() {
      this.isMobileView = window.innerHeight < 991;
      // Berechne Button-Größe prozentual zur Bildschirmhöhe
      // Bei 600px Höhe = 52px, bei 1000px+ Höhe = 78px
      const minSize = 70;
      const maxSize = 92;
      const minFontSize = 17;
      const maxFontSize = 24;
      const minHeight = 800;
      const maxHeight = 1200;
      
      const currentHeight = window.innerHeight;
      
      if (currentHeight <= minHeight) {
        this.buttonSize = minSize;
        this.buttonFontSize = minFontSize;
      } else if (currentHeight >= maxHeight) {
        this.buttonSize = maxSize;
        this.buttonFontSize = maxFontSize;
      } else {
        // Lineare Interpolation zwischen min und max
        const percentage = 0.6 * (currentHeight - minHeight) / (maxHeight - minHeight);
        this.buttonSize = Math.round(minSize + (maxSize - minSize) * percentage);
        this.buttonFontSize = Math.round(minFontSize + (maxFontSize - minFontSize) * percentage);
      }
    },
    markAsDuplicate() {
      this.sidePanelInventoryVenueWine.duplicate = !this.sidePanelInventoryVenueWine.duplicate;
      var alertobject = {
        text: this.$t("inventory.duplicateMarked"),
        variant: "info"
      };
      this.$store.commit("setAlertText", alertobject);
      this.nextRow();
    },
    emitUpdate() {
      this.sidePanelInventoryVenueWine.purchasePrice = checkForNullEmptyOrNegative(this.sidePanelInventoryVenueWine.purchasePrice);
      this.sidePanelInventoryVenueWine.sellingPrice = checkForNullEmptyOrNegative(this.sidePanelInventoryVenueWine.sellingPrice);
      this.$emit('updateFromSidePanel', this.sidePanelInventoryVenueWine);
    },

    nextRow() {
      this.actualAmountFloatChanged = false;
      this.saveInventoryVenueWine();
      if (this.selectedRowIndex === this.tableLength - 1) {
        this.$nextTick(() => {
          this.$emit('nextRow', this.sidePanelInventoryVenueWine, 0);
        });
      } else {
        this.$emit('nextRow', this.sidePanelInventoryVenueWine);
      }
    },
    previousRow() {
      this.actualAmountFloatChanged = false;
      this.$emit('previousRow');
      this.saveInventoryVenueWine();
    },
    resetInputs() {
      this.sidePanelInventoryVenueWine = {
        purchasePrice: 0,
        shelf: '',
        actualAmountFloat: null,
        targetAmountFloat: 0,
        duplicate: false,
        id: null,
        sellingPrice: 0,
        year: null,
        bottleSize: null
      }
      this.duplicateProductError = false;
    },
    async saveInventoryVenueWine() {
      let inventoryVenueWineState = Constants.inventory.CHECKED
      /* Sidepanel-Verhalten: wenn nur auf nächstes geklickt: Anzahl 0 setzen und nicht auf checked setzen */
      if (this.sidePanelInventoryVenueWine.actualAmountFloat === null && !this.sidePanelInventoryVenueWine.duplicate  ) {
        inventoryVenueWineState = Constants.inventory.NONE
        this.sidePanelInventoryVenueWine.actualAmountFloat = null;
      }
      this.sidePanelInventoryVenueWine.inventoryVenueWineState = inventoryVenueWineState;
      this.sidePanelInventoryVenueWine.targetAmountFloat = Number(this.sidePanelInventoryVenueWine.targetAmountFloat);
      DataService.updateInventoryVenueWine(this.selectedInventoryVenueWine.id, this.sidePanelInventoryVenueWine).then(() => {
      }).catch((err) => {
        console.log('err :>> ', err);
      })
    },
    addNumber(n) {     
      this.sidePanelInventoryVenueWine.actualAmountFloat = this.sidePanelInventoryVenueWine.actualAmountFloat === null ? 0 : this.sidePanelInventoryVenueWine.actualAmountFloat;
      this.actualAmountFloatChanged = true;
      if (this.sidePanelInventoryVenueWine.actualAmountFloat === 0 || this.sidePanelInventoryVenueWine.actualAmountFloat === null || this.sidePanelInventoryVenueWine.actualAmountFloat === '0') {
        this.sidePanelInventoryVenueWine.actualAmountFloat = n.toString();
      } else {
        this.sidePanelInventoryVenueWine.actualAmountFloat += n.toString();
      }
      this.emitUpdate();
    },
		addComma() {
			this.sidePanelInventoryVenueWine.actualAmountFloat = this.sidePanelInventoryVenueWine.actualAmountFloat === null ? 0 : this.sidePanelInventoryVenueWine.actualAmountFloat;
			this.actualAmountFloatChanged = true;
			const hasComma = this.sidePanelInventoryVenueWine.actualAmountFloat.includes('.');
			if (this.sidePanelInventoryVenueWine.actualAmountFloat === 0 || this.sidePanelInventoryVenueWine.actualAmountFloat === null || this.sidePanelInventoryVenueWine.actualAmountFloat === '0') {
				this.sidePanelInventoryVenueWine.actualAmountFloat = '0.';
			} else if (!hasComma)  {
				this.sidePanelInventoryVenueWine.actualAmountFloat += '.';
			}
			this.emitUpdate();
		},
    deleteNumber() {
      
      this.actualAmountFloatChanged = true;
      if (this.sidePanelInventoryVenueWine.actualAmountFloat === null) {
        return
      }
      this.sidePanelInventoryVenueWine.actualAmountFloat = this.sidePanelInventoryVenueWine.actualAmountFloat.toString();
      if (this.sidePanelInventoryVenueWine.actualAmountFloat.length === 1) {
        this.sidePanelInventoryVenueWine.actualAmountFloat = null;
      } else {
        this.sidePanelInventoryVenueWine.actualAmountFloat = this.sidePanelInventoryVenueWine.actualAmountFloat.slice(0, -1);
      }
      this.emitUpdate();
    },
    reduceTextFn(text, length, addDots) {
      return reduceText(text, length, addDots);
    },
    changeYear(year) {
      // Convert year to integer to ensure proper data type
      this.sidePanelInventoryVenueWine.year = parseInt(year) || 0;
      this.onFieldChange();
      this.checkForDuplicateProduct();
    },
    changeBottleSize(bottleSize) {
      this.sidePanelInventoryVenueWine.bottleSize = bottleSize;
      this.onFieldChange();
      this.checkForDuplicateProduct();
    },
    onFieldChange() {
      if (!this.hasUnsavedChanges && this.originalValues) {
        this.hasUnsavedChanges = true;
      }
    },
    saveChanges() {
      // Speichern der Änderungen
      this.originalValues = JSON.parse(JSON.stringify(this.sidePanelInventoryVenueWine));
      this.hasUnsavedChanges = false;
      
      // Änderungen persistieren
      DataService.updateInventoryVenueWine(this.selectedInventoryVenueWine.id, this.sidePanelInventoryVenueWine)
        .then(() => {
          var alertobject = {
            text: "Produkteigenschaft geändert",
            variant: "success"
          };
          this.$store.commit("setAlertText", alertobject);
          this.emitUpdate();
        })
        .catch((err) => {
          console.log('err :>> ', err);
          var alertobject = {
            text: this.$t("general.errorSaving"),
            variant: "danger"
          };
          this.$store.commit("setAlertText", alertobject);
        });
    },
    cancelChanges() {
      // Änderungen verwerfen
      if (this.originalValues) {
        this.sidePanelInventoryVenueWine = JSON.parse(JSON.stringify(this.originalValues));
      }
      this.hasUnsavedChanges = false;
      this.checkForDuplicateProduct();
    },
    checkForDuplicateProduct() {
      if (!this.selectedInventoryVenueWine || !this.inventoryWines) {
        this.duplicateProductError = false;
        return;
      }

      const currentWineId = this.selectedInventoryVenueWine.venueWine.wine.id;
      const currentVenueWineTitle = this.selectedInventoryVenueWine.venueWine.title;
      const currentYear = this.sidePanelInventoryVenueWine.year;
      const currentBottleSizeId = this.sidePanelInventoryVenueWine.bottleSize ? 
        (typeof this.sidePanelInventoryVenueWine.bottleSize === 'object' ? 
         this.sidePanelInventoryVenueWine.bottleSize.id : 
         this.sidePanelInventoryVenueWine.bottleSize) : null;

      // Check if another wine in the inventory has the same combination
      const duplicate = this.inventoryWines.find(wine => {
        // Skip the current wine itself
        if (wine.id === this.selectedInventoryVenueWine.id) {
          return false;
        }

        const wineId = wine.venueWine?.wine?.id;
        const venueWineTitle = wine.venueWine?.title;
        const year = wine.year;
        const bottleSizeId = wine.bottleSize ? 
          (typeof wine.bottleSize === 'object' ? 
           wine.bottleSize.id : 
           wine.bottleSize) : null;

        return wineId === currentWineId && 
               venueWineTitle === currentVenueWineTitle &&
               year === currentYear && 
               bottleSizeId === currentBottleSizeId;
      });

      this.duplicateProductError = !!duplicate;
    },
  }
}
</script>
<style scoped>
div.sidepanel {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 389px;
  width: 389px;
  top: 0;
  background-color: var(--color-gray-300);
  padding: var(--margin-s) var(--margin-m) var(--margin-m) var(--margin-m);
  flex-direction: column;
  transition: margin 0.8s;
  margin-right: -389px;
  justify-content: space-between;
  border-radius: 8px;
  position: relative;
  z-index: 100;
}

div.sidepanel.active {
  right: 0;
  transform: translateX(0);
  margin-right: 0;
}

.overlay {
  position: absolute;
  width: 200vw;
  height: 200vh;
  top: -100vh;
  left: -100vw;
  right: 0;
  bottom: 0;
  background-color: rgba(34, 35, 37, 0.77);
  z-index: 10;
  border-radius: 8px;
}

div.block-one {
  position: absolute;
  z-index: 1;
  padding: var(--margin-s);
  background-color: var(--color-gray-400);
  border-radius: 8px;
  width: calc(100% - 2 * var(--margin-m));
}

div.block-one.elevated {
  z-index: 20;
}

div.block-two {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

div.calculate {
  flex-grow: 1;
}

span.box {
  display: inline;
  padding: 4px 8px;
}

div.tags {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
}

button.number {
  display: flex;
  padding: var(--margin-s);
  justify-content: center;
  align-items: center;
  background-color: var(--color-gray-400);
  border-radius: 6px;
  border: none;
}

.duplicate {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
}

div.calculate {
  flex-direction: column;
}

div.number-row {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px
}

.number-pad {
  width: 187px;
  margin-top: 20px;
}

.bottom-row {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 8px;
}

.bottom-row .delete-btn {
  height: 52px;
  width: 52px;
}

.buttons * {
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
}

.amount-not-set {
  opacity: 0.4;
}

.input-euro {
     position: relative;
 }
 .input-euro.left input {
     padding-left:18px;
 }
 .input-euro.right input {
     padding-right:18px;
     text-align:start; 
 }

 .input-euro:before {
     position: absolute;
     top: 0;
     content:"€";
 }
 .input-euro.left:before {
     left: 5px;
 }
 .input-euro.right:before {
     right: 5px;
 }

.disabled {
  opacity: 0.4!important;
  pointer-events: none;
  cursor: not-allowed !important;
}

.delete-btn.disabled {
  opacity: 0.4!important;
  pointer-events: none;
  cursor: not-allowed !important;
}

.sidepanel input:disabled {
  opacity: 0.4!important;
  pointer-events: none;
  cursor: not-allowed;
  background-color: var(--color-gray-300);
}

.inactive {
  opacity: 0.4 !important;
  pointer-events: none;
}

.save-cancel-buttons {
  gap: 10px;
}

.btn-save {
  background-color: var(--color-success) !important;
  color: white !important;
  border: none;
  width: 100%;
  padding: var(--margin-s) var(--margin-m);
  font-weight: 700;
}

.btn-cancel {
  background-color: var(--color-gray-300) !important;
  color: var(--color-gray-100) !important;
  border: none;
  width: 100%;
  padding: var(--margin-s) var(--margin-m);
  font-weight: 700;
}

</style>